module.exports = __webpack_public_path__ + "img/yacy.png";